{
  "active": "Активные",
  "pinned": "Закреплённые",
  "read": "Прочитанные",
  "inactive": "Неактивные",
  "empty": "Пока нет активности агентов.",
  "loadMore": "Показать ещё",
  "openProject": "Откройте проект, чтобы видеть агентов.",
  "loadError": "Не удалось загрузить агентов.",
  "pin": "Закрепить агента",
  "unpin": "Открепить агента",
  "unpinConfirm": "Открепить агента?",
  "working": "Агент работает",
  "surfaces": {
    "shots_assistant": "Сториборд",
    "script_assistant": "Сценарий",
    "scene3d_assistant": "3D-сцены",
    "skills_discussion_assistant": "Скиллы: обсудить",
    "skills_editor_assistant": "Скиллы: редактировать",
    "projects_assistant": "Проекты"
  },
  "preview": {
    "agent": "Агент",
    "you": "Вы",
    "empty": "нет сообщений"
  }
}
